const state = {
  // 控制展示“二维码”
  showQRCode: false,
};
const getters = {
  isShowQRCode: state => {
    return state.showQRCode;
  }
};

const mutations = {
  SHOW_QR_CODE_STATUS(state, show) {
    state.showQRCode = (show === true);
  }
}
const actions = {
  setShowQRCode({
    commit
  }, show) {
    commit('SHOW_QR_CODE_STATUS', show);
  }
}
export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/QRCode.js